import styled from 'styled-components';

//Icons
import { ReactComponent as CommentIcon } from '../../../../assets/icons/comment-icon.svg';

//Components
import CustomCell from './customCell';
import StatusCell from './statusCell';

// import theme
import { colors } from '../../../../theme';
import { useAppSelector } from '../../../../hooks/hooks';
import { TERM_PLANNER_CANCELLED_STATUS_ID } from '../../../../constants';

const Grid = (props: any) => {
    const { sort, filter } = props;

    const termPlannerState = useAppSelector((state) => state.termPlanner);

    const sortData = (data: any) => {
        let newData = [...data];

        if (!sort) return;

        let compareFunction;
        if (sort === 'subjectCode') {
            compareFunction = (a: any, b: any) => {
                if (a.course < b.course) return -1;
            };
        }
        if (sort === 'room') {
            compareFunction = (a: any, b: any) => {
                if (!a.initialRoom || !b.initialRoom) return;
                if (parseInt(a.initialRoom) < parseInt(b.initialRoom)) return -1;
            };
        }
        if (sort === 'capacityLow') {
            compareFunction = (a: any, b: any) => {
                if (parseInt(a.capacity) < parseInt(b.capacity)) return -1;
            };
        }
        if (sort === 'capacityHigh') {
            compareFunction = (a: any, b: any) => {
                if (parseInt(a.capacity) > parseInt(b.capacity)) return -1;
            };
        }
        // else {
        //     compareFunction = (a: any, b: any) => {
        //         if (a[sort] > b[sort]) return -1;
        //         if (b[sort] > a[sort]) return 1;
        //         else return 0;
        //     };
        // }

        return newData.sort(compareFunction);
    };

    const filterData = (data: any) => {
        let newData = [...data];

        if (filter.subject) {
            newData = newData.filter((o) => {
                return o.course.toLowerCase().includes(filter.subject.toLowerCase());
            });
        }

        if (filter.crn) {
            newData = newData.filter((o) => {
                return o.crn.toString().includes(filter.crn);
            });
        }

        if (filter.instructor) {
            newData = newData.filter((o) => {
                return o.initialInstructors.toLowerCase().includes(filter.instructor.toLowerCase());
            });
        }

        if (filter.status) {
            newData = newData.filter((o) => {
                const status: any = termPlannerState.statuses.find((s: any) => s.id === o.statusId);
                let statusName = 'N/A';
                if (status) statusName = status.name;
                return statusName === filter.status.item;
            });
        }

        return newData;
    };

    return (
        <StyledTable>
            <thead>
                <tr>
                    <th className="course-col">Course</th>
                    <th className="room-col">Room</th>
                    <th className="date-col">Date</th>
                    <th className="time-col">Time</th>
                    <th className="instructor-col">Instructor</th>
                    <th className="status-col">Status</th>
                </tr>
            </thead>
            <StyledTableBody>
                {sortData(filterData(termPlannerState.termPlan?.items)).map((o, i) => {
                    return (
                        <>
                            <tr className={`firstRow`}>
                                <td className={`courseInfo`} rowSpan={2}>
                                    <div className={`courseCode ${o.status === 'cancelled' && 'text-red-line'}`}>
                                        {o.course} <span> • </span> {o.crn}
                                    </div>
                                    <CourseName>{o.courseName}</CourseName>
                                </td>

                                {/* Room */}
                                <td className={`room-col ${o.statusId === TERM_PLANNER_CANCELLED_STATUS_ID && 'text-red-line'}`}>
                                    <CustomCell data={o} initialField="initialRoom" currentField={'currentRoom'} inputName="room" />
                                </td>

                                {/* Date */}
                                <td className={`date-col ${o.statusId === TERM_PLANNER_CANCELLED_STATUS_ID && 'text-red-line'}`}>
                                    <CustomCell data={o} initialField="initialDate" currentField={'currentDate'} inputName="date" />
                                </td>

                                {/* Time */}
                                <td className={`time-col ${o.statusId === TERM_PLANNER_CANCELLED_STATUS_ID && 'text-red-line'}`}>
                                    <CustomCell data={o} initialField="initialTime" currentField={'currentTime'} inputName="time" />
                                </td>

                                {/* Instructor(s) */}
                                <td className={`instructor-col ${o.statusId === TERM_PLANNER_CANCELLED_STATUS_ID && 'text-red-line'}`}>
                                    <CustomCell data={o} initialField="initialInstructors" currentField={'currentInstructors'} inputName="instructor" />
                                </td>

                                {/* Status */}
                                <td style={{ textTransform: 'uppercase', position: 'relative', textAlign: 'left' }}>
                                    <StatusCell data={o} />
                                </td>
                            </tr>
                            <tr className={`SecondRow`}>
                                <td colSpan={4} className={`${o.id}-comment comment-col`}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <CommentIcon color={colors.blue.main} />
                                        <CustomCell data={o} initialField="note" currentField={'note'} inputName="note" />
                                    </div>
                                </td>
                                <td colSpan={1} className="course-extra-col">
                                    <span> {o.sets}</span>
                                    <span>{o.timeslots}</span>
                                    {/*TODO: (PS) do we need this?*/}
                                    {/*<span>{o.days}</span>*/}
                                    <span>
                                        {' '}
                                        {o.enrolled} / {o.capacity}
                                    </span>
                                </td>
                            </tr>
                            <Spacer />
                            <Spacer />
                        </>
                    );
                })}
            </StyledTableBody>
        </StyledTable>
    );
};

export default Grid;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-weight: 400;

    thead {
        text-align: left;
        color: ${colors.grey.dark};
    }

    th {
        padding: 13px 0;
    }

    td {
        letter-spacing: -0.025em;

        p.new {
            color: ${colors.green.main};
            margin: 0px;
        }
    }

    .course-col {
        width: 15%;
        padding-left: 18px;
    }

    .instructor-col {
        width: 20%;
        padding-right: 10px;

        & > div {
            max-width: 300px;
        }
    }

    .date-col {
        width: 20%;
        padding: 0px 5px;

        & > div {
            max-width: 300px;
        }
    }

    .time-col {
        width: 18%;

        & > div {
            max-width: 250px;
        }
    }

    .room-col {
        width: 9%;
        padding: 0px 5px 0px 10px;

        & > div {
            max-width: 110px;
        }
    }

    .status-col {
        width: 11%;
    }

    /* input {
        margin-right: -5px;
        padding: 0px;
        font-size: 12px;
        border: 1px solid ${colors.grey.medium};
        border-radius: 3px;
    } */
`;

const StyledTableBody = styled.tbody`
  tr {
    background: ${colors.white};
    font-size: 12px;
  }

  tr:nth-child(odd) td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  tr:nth-child(odd) td:last-child {
    border-top-right-radius: 10px;
  }

  tr:nth-child(even) td:last-child {
    border-bottom-right-radius: 10px;
  }

  .firstRow {
    .courseInfo {
      border-right: 1px solid ${colors.bg};
    }

    td:nth-child(1) {
      padding: 15px 10px 15px 15px;
    }

    .courseCode {
      font-size: 14px;
    }
  }

  .SecondRow {
    border-top: 1px solid ${colors.bg};
    width: 100%;

    .comment-col {
      text-align: left;
      font-size: 13px;
      letter-spacing: -0.015em;

      svg {
        margin: 10px 10px 10px 15px;
        vertical-align: middle;
        path: {
          fill: ${colors.blue.main};
        }
      }
    }
  }

  .course-extra-col {
    color: ${colors.grey.medium};
    text-align: left;
    padding-right: 10px;

    & > span {
      padding: 2px;
      border-radius: 5px;
      background-color: ${colors.grey.light};
      margin-right: 4px;
    }
  }
}

.text-red-line {
  color: ${colors.red.main};
  -webkit-text-decoration: line-through; /* Safari */
  text-decoration: line-through;
}

.text-red {
  color: ${colors.red.main};
}

.text-blue {
  color: ${colors.blue.main};
}

.text-green {
  color: ${colors.green.main};
}
`;

const CourseName = styled.div`
    color: ${colors.grey.medium};
    font-size: 11px;
    margin-top: 5px;
    -webkit-text-decoration: none; /* Safari */
    text-decoration: none;
    letter-spacing: -0.03em;
`;
const Spacer = styled.div`
    height: 5px;
`;
